import styled from "styled-components"

export const HeaderWrapper = styled.div`
    width: 100%;
    background-color: #741b75 ;
    position: fixed;
    top: 0;
    z-index: 10;
    box-shadow: 0px 4px 8px rgba(34, 24, 24, 0.4);

    .box_center{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
    }
    .logo_main{
        img{
            height: 70px;
        }
    }
    .news_logo{
        i{
            color: #ffffff;
            font-size: 2.2rem;
        }
    }
    .navSocial_new{
        background-color: #ffffff;
        p{
            font-size: 1.0rem;
        }
        border-radius: 4px;
        padding: 0 4px;
    }
    .box_profile{
        display: flex;
        align-items: center;
        .user{
            margin-left: 32px;
        }
    }
           
            .menu{
                margin-left: 12px;
                cursor: default;
                &_name{
                color: #ffffff;
                display: flex;
                align-items: center;
                    svg{
                        margin-right:4px;
                    }
                }
            &:hover .submenu{
                display: block;
            }
                    position: relative;
                    &_name{
                        color: #ffffff;
                    }
                    .submenu{
                        position: absolute;
                        background-color: #ffffff;
                        top: 30px;
                        list-style: none;
                        padding: 0;
                        border-radius: 5px;
                        left: 60%;
                        transform: translateX(-50%);
                        box-shadow: 1px 1px 4px rgb(0 0 0 / 15%);
                        z-index: 15;
                        display: none;
                        animation: fadeOpacity linear 0.5s;
                        .submenu_item{
                            &:first-child{
                            a{
                                border-top-left-radius: 5px;
                                border-top-right-radius: 5px;
                            }
                            }
                        &:last-child{
                            a{
                                border-bottom-left-radius: 5px;
                                border-bottom-right-radius: 5px;
                            }
                            }
                            a{
                                list-style: none;
                                display: block;
                                white-space: nowrap;
                                padding: 4px 12px;
                                &:hover{
                                    background-color: #e2c1c1;
                                    color: #741b75;
                                }
                            }
                        }
                    }
                    &::after{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 10px;
                    display: block;
                }
                }    
    .navbar{
        width: 1200px;
    }
    @keyframes fadeOpacity {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
`
